import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo, useEffect, Fragment as Fragment$1 } from "react";
import { useSelector } from "react-redux";
import { selectRegistrationStarted } from "@nxplatform/geo-data/slices/ip-data.slice";
import { selectSocialRegistrationStarted, selectSocialLoginStarted } from "@nxplatform/store-shared/authentication/shared-authentication-selectors";
import { selectCustomerTokenEntities } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { selectBalticStatesProviderSessionData } from "@service/authentication/slices/authentication.slice";
import { isTopBluemRegistrationStarted } from "@service/authentication/slices/bluem-registration.slice";
import { MainLoader } from "./common/ui/elements/main-loader/index.js";
import { useBodyClassToggler } from "./hooks/body-class.hook.js";
import { RouteSwitcher as _RouteSwitcher } from "./platform-route-switcher.js";
import { PlatformRouter as _PlatformRouter } from "./platform-router.js";
import { useJWTAuthorizationHook } from "./hooks/authorization/jwt-authorization.hook.js";
import { selectIsSmarticoEnabled, selectRegistrationSuccessLogoUrl } from "@nxplatform/platform-settings/platform-settings.selectors";
import { addMiddleware } from "@nxplatform/store-utils/module-manager/middleware-manager";
import './assets/platform-routes.css';const showLoaderClass = "show-loader";
const PlatformRoot = ({
  layouts,
  platformRoutes,
  container = Fragment$1,
  hideRegistrationLoader,
  additionalLayouts,
  rootElement
}) => {
  const registrationStarted = useSelector(selectRegistrationStarted);
  const socialRegistrationStarted = useSelector(selectSocialRegistrationStarted);
  const socialLoginStarted = useSelector(selectSocialLoginStarted);
  const isSmarticoEnabled = useSelector(selectIsSmarticoEnabled);
  const auth = useSelector(selectCustomerTokenEntities);
  const registrationSuccessLogoUrl = useSelector(selectRegistrationSuccessLogoUrl);
  const startTopBluemRegistration = useSelector(isTopBluemRegistrationStarted);
  const balticStatesProviderSession = useSelector(selectBalticStatesProviderSessionData);
  const { allowRouteRendering } = useJWTAuthorizationHook();
  const showMainLoader = registrationStarted && !hideRegistrationLoader && !balticStatesProviderSession || socialRegistrationStarted || socialLoginStarted || startTopBluemRegistration;
  useBodyClassToggler({
    triggerer: [showMainLoader],
    className: showLoaderClass,
    htmlClassName: showLoaderClass
  });
  useEffect(() => {
    if (!auth || !isSmarticoEnabled) return;
    import("@nxplatform/customer/middlewares/smartico.middleware").then((m) => {
      if (m.smarticoMiddleware) {
        addMiddleware([m.smarticoMiddleware]);
      }
    });
  }, [isSmarticoEnabled, auth]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    showMainLoader && /* @__PURE__ */ jsx(
      MainLoader,
      {
        hideRegistrationText: socialLoginStarted,
        url: registrationSuccessLogoUrl || "/assets/registration_loader.gif",
        alt: "loader"
      }
    ),
    allowRouteRendering && platformRoutes && /* @__PURE__ */ jsx(
      _PlatformRouter,
      {
        platformRoutes
      }
    ),
    allowRouteRendering && layouts && /* @__PURE__ */ jsx(
      _RouteSwitcher,
      {
        layouts,
        Container: container,
        additionalLayouts,
        RootElement: rootElement
      }
    )
  ] });
};
const _PlatformRoot = memo(PlatformRoot);
export {
  _PlatformRoot as PlatformRoot
};
